import React from 'react';
import { useFormik } from 'formik';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import images from 'assets/images';
import { ReactComponent as PrevIconSVG } from 'assets/images/location/prev-icon.svg';

import Button from 'components/App/Button';
import Card from 'components/App/Card';

import { LOCATIONS } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';
import MODAL_TYPE from 'constants/modalType';
import TAB from 'constants/tab';

import AppLink from 'components/App/AppLink';
import PAYMENT_METHODS from './paymentMethods';
import styles from './StepPayment.module.scss';

function StepPayment(props) {
  const {
    isLoadingCreateNewPlace,

    location,
    // setting,

    actionCreateNewPlace,
    actionOpenModalCreatePlaceSuccess,
    actionAddLocationByStep,
    onBack,
    setIsValid,
  } = props;

  // const [isShowInformation, setIsShowInformation] = useState('allow');

  // const onChangeRadio = useCallback(
  //   (e) => {
  //     setIsShowInformation(e.target.value);
  //   },
  //   [isShowInformation],
  // );

  const history = useHistory();

  const [isUpdateNeeded, setIsUpdateNeeded] = React.useState(false);
  const [policy1Checked, setPolicy1Checked] = React.useState(false);
  const [policy2Checked, setPolicy2Checked] = React.useState(false);

  const initialValues = React.useMemo(() => {
    const values = {};

    PAYMENT_METHODS.forEach((section) => {
      (section.children || []).forEach((child) => {
        values[child.name] = false;
      });
    });

    const savedMethods = location?.paymentMethods || [];
    savedMethods.forEach((method) => {
      (method.children || []).forEach((childName) => {
        values[childName] = true;
      });
    });

    return values;
  }, [location]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues,

    onSubmit: (values) => {
      const callbackSuccess = () => {
        history.push(LOCATIONS.LOCATION_LIST);
        actionOpenModalCreatePlaceSuccess(MODAL_TYPE.CREATE_PLACE_SUCCESS);
      };

      const paymentMethods = PAYMENT_METHODS.map((section) => {
        const activeChildren = (section.children || [])
          .filter((child) => !!values[child.name])
          .map((child) => ({ name: child.name, bin: child.bin }));
        return {
          group: section.group,
          children: activeChildren,
        };
      }).filter((method) => method.children.length > 0);

      actionCreateNewPlace({
        location: {
          ...location,
          paymentMethods,
        },
        callback: callbackSuccess,
      });
    },
  });

  const onChangePaymentMethods = (e) => {
    const { id, checked } = e.target;

    validation.setFieldValue(id, checked, true);

    setIsUpdateNeeded(true);
  };

  React.useEffect(() => {
    if (isUpdateNeeded) {
      const paymentMethods = PAYMENT_METHODS.map((section) => {
        const activeChildren = (section.children || [])
          .filter((child) => !!validation.values[child.name])
          .map((child) => ({ name: child.name, bin: child.bin }));
        return {
          group: section.group,
          children: activeChildren,
        };
      }).filter((method) => method.children.length > 0);

      actionAddLocationByStep({
        step: TAB.PAYMENT,
        location: {
          ...location,
          paymentMethods,
        },
      });

      setIsUpdateNeeded(false);
    }
  }, [validation.values, actionAddLocationByStep, location, isUpdateNeeded]);

  const onChangePolicyCheckBox = (e) => {
    const { id, checked } = e.target;
    if (id === 'policy1') {
      setPolicy1Checked(checked);
    } else {
      setPolicy2Checked(checked);
    }
  };

  React.useEffect(() => {
    setIsValid(validation.isValid);
  }, [setIsValid, validation.isValid]);

  return (
    <form className={styles.Component} onSubmit={validation.handleSubmit}>
      <Card className={styles.Card}>
        <h3 className={styles.Title}>
          Lựa chọn thanh toán dịch vụ tại chỗ nghỉ
          <span className={styles.TextRequired}>*</span>
        </h3>

        {PAYMENT_METHODS.map((section) => {
          let displayChildren;
          if (section.group === 'INTERNATIONAL') {
            displayChildren = section.children.filter((child) =>
              ['MASTERCARD', 'VISA', 'JCB', 'AMERICAN EXPRESS'].includes(child.name),
            );
          } else if (section.group === 'DOMESTIC') {
            displayChildren = section.children.filter((child) => child.name === 'NAPAS');
          } else {
            displayChildren = section.children;
          }

          return (
            <div key={section.group} className={styles.PaymentMethodWrap}>
              <p className={styles.PaymentMethodTitle}>
                {section.group === 'CASH' ? 'Khác' : section.vi}
              </p>

              <div className={styles.PaymentMethod}>
                {displayChildren.map((card) => (
                  <div key={card.name} className={styles.Checkbox}>
                    <Input
                      id={card.name}
                      name={section.group}
                      type="checkbox"
                      className={styles.CheckboxInput}
                      onChange={onChangePaymentMethods}
                      checked={!!validation.values[card.name]}
                    />

                    <label className={styles.CheckboxLabel} htmlFor={card.name}>
                      {images[card.name] && (
                        <img
                          src={images[card.name].default || images[card.name]}
                          alt="payment"
                        />
                      )}

                      <span>{card.vi || card.name}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </Card>

      <Card className={styles.Card}>
        <h3 className={styles.Title}>Quý vị sắp hoàn tất rồi – chỉ còn vài điều lưu ý cuối cùng</h3>

        <p className={styles.Description}>
          Để giúp Quý vị bắt đầu kiếm doanh thu, chúng tôi sẽ tự động mở chỗ
          nghỉ của Quý vị cho khá ch đặt trong 18 tháng tới. Nếu muốn thay đổi
          tình trạng phòn g trống trước khi mở, Quý vị có thể chọn &ldquo;hoàn
          tất đăng ký và mở sau&ldquo; . Tình trạng phòng trống cũng có thể được
          điều chỉnh sau khi Quý vị mở phòng cho khách đặt.
        </p>
      </Card>

      <Card className={styles.Card}>
        <h3 className={styles.Title}>
          Để hoàn tất đăng ký, vui lòng đánh dấu vào những ô dưới đây:
        </h3>

        <div className={styles.InputWrap}>
          <Input
            id="policy1"
            className={styles.Checkbox}
            type="checkbox"
            checked={policy1Checked}
            onChange={onChangePolicyCheckBox}
          />

          <label htmlFor="policy1" className={styles.Label}>
            Tôi chứng nhận đây là hoạt động kinh doanh lưu trú hợp pháp được cấp
            đầy đủ bằng và giấy phép cần thiết, có sẵn để trình khi có yêu cầu.
            Bookese.com B.V. có quyền kiểm chứng và điều tra bất kỳ thông tin
            bên Quý vị cung cấp khi đăng ký.
          </label>
        </div>

        <div className={styles.InputWrap}>
          <Input
            id="policy2"
            className={styles.Checkbox}
            type="checkbox"
            checked={policy2Checked}
            onChange={onChangePolicyCheckBox}
          />

          <label htmlFor="policy2" className={styles.Label}>
            Tôi đã đọc, chấp nhận và đồng ý với
            {' '}
            <AppLink href="##" className={styles.Link}>
              Điều khoản chung
            </AppLink>
            {' '}
            và
            {' '}
            <AppLink href="##" className={styles.Link}>
              Chính sách An toàn và Bảo mật.
            </AppLink>
          </label>
        </div>
      </Card>

      <div className={styles.FormAction}>
        <Button
          classes="Btn Btn__PrevStep"
          outline
          onClick={onBack(TAB.POLICY)}
        >
          <PrevIconSVG className="Icon__PrevStep" />
          Quay về bước trước
        </Button>

        <Button
          classes="Btn Btn__NextStep"
          type="submit"
          loading={isLoadingCreateNewPlace}
          disabled={!policy1Checked || !policy2Checked}
        >
          Tạo chỗ nghỉ
        </Button>
      </div>
    </form>
  );
}

StepPayment.propTypes = {
  isLoadingCreateNewPlace: PropTypes.bool.isRequired,

  location: PropTypes.instanceOf(Object),
  // setting: PropTypes.instanceOf(Object),

  actionCreateNewPlace: PropTypes.func.isRequired,
  actionOpenModalCreatePlaceSuccess: PropTypes.func.isRequired,
  actionAddLocationByStep: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  setIsValid: PropTypes.func,
};

StepPayment.defaultProps = {
  location: INITIAL_VALUE.OBJECT,
  // setting: INITIAL_VALUE.OBJECT,

  onBack: INITIAL_VALUE.FUNCTION,
  setIsValid: INITIAL_VALUE.FUNCTION,
};

export default React.memo(StepPayment);
